import { styled } from '@mui/material';

import type { AdditionalInfoProps } from './AdditionalInfo.types';

export function AdditionalInfo({ children, variant }: AdditionalInfoProps) {
  if (!children) {
    return null;
  }

  return <InfoBox variant={variant}>{children}</InfoBox>;
}

const InfoBox = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant?: 'error' | 'info' | 'success' }>(({ theme, variant }) => {
  let backgroundColor = theme.tokens.additionalInfoBackgroundInfo;
  let borderColor = theme.tokens.additionalInfoBorderInfo;

  if (variant === 'error') {
    backgroundColor = theme.tokens.additionalInfoBackgroundWarning;
    borderColor = theme.tokens.additionalInfoBorderWarning;
  } else if (variant === 'success') {
    backgroundColor = theme.tokens.additionalInfoBackgroundSuccess;
    borderColor = theme.tokens.additionalInfoBorderSuccess;
  }

  return {
    width: '100%',
    padding: theme.spacing(4, 3),
    borderTop: `${theme.borders.borderWidth1} ${borderColor}`,
    backgroundColor: backgroundColor,
  };
});
